export const ProductsNavigation = [
    {
        text: 'Products',
        icon: 'box',
        path: '/products/list'
    },{
        text: 'Product Groups',
        icon: 'bulletlist',
        path: '/products/producttype'
    },/*{
        text: 'Inventories',
        icon: 'inactivefolder',
        path: '/products/inventory'
    },*/
];